import React from 'react';
import { UsersIcon } from 'lucide-react';
interface ScarcityBarProps {
  tone?: 'light' | 'dark';
  spotsLeft?: number;
}
export function ScarcityBar({
  tone = 'light',
  spotsLeft = 9
}: ScarcityBarProps) {
  const isDark = tone === 'dark';
  return <div className={`w-full rounded-2xl border p-4 ${isDark ? 'border-gold-500/30 bg-navy-950/50' : 'border-gold-500/40 bg-gold-100/70'}`} data-id="element-305" data-mp="2l4o3n8sz25h4">
      <div className="flex items-center justify-between gap-3" data-id="element-306" data-mp="2b56zwwxa61ns">
        <p className={`flex items-center gap-1.5 text-[12px] font-extrabold uppercase tracking-tight ${isDark ? 'text-cream-100' : 'text-navy-900'}`} data-id="element-307" data-mp="2g63aftc50m26">
          <UsersIcon className="h-4 w-4 shrink-0 text-gold-500" aria-hidden="true" data-id="element-308" data-mp="274d8vuojk6qo" />
          Launch price spots
        </p>
        <span className="flex items-center gap-1.5 text-[12px] font-extrabold text-clinical-red" data-id="element-309" data-mp="g0arvatoqkx">
          <span className="animate-scarcity-pulse inline-block h-2 w-2 rounded-full bg-clinical-red" aria-hidden="true" data-id="element-310" data-mp="5ch18w5hvh16" />
          {spotsLeft} left
        </span>
      </div>

      <div className={`mt-2.5 h-3 w-full overflow-hidden rounded-full ${isDark ? 'bg-cream-100/15' : 'bg-navy-900/10'}`} role="progressbar" aria-valuenow={94} aria-valuemin={0} aria-valuemax={100} aria-label="Launch price spots claimed" data-id="element-311" data-mp="2zkrsdmcppqg8">
        <div className="h-full rounded-full bg-clinical-red" style={{
        width: '94%'
      }} data-id="element-312" data-mp="2kq3fvo8w9rr4" />
      </div>

      <p className={`mt-2 text-[11px] font-medium leading-snug ${isDark ? 'text-cream-100/70' : 'text-navy-700/80'}`} data-id="element-313" data-mp="2ulx1ry8i6xlk">
        94% claimed — only {spotsLeft} spots remain at the $27 promotional price.
      </p>
    </div>;
}